const ONES = [
  'zero',
  'one',
  'two',
  'three',
  'four',
  'five',
  'six',
  'seven',
  'eight',
  'nine',
]

const TEENS = [
  'ten',
  'eleven',
  'twelve',
  'thirteen',
  'fourteen',
  'fifteen',
  'sixteen',
  'seventeen',
  'eighteen',
  'nineteen',
]

const TENS = [
  '',
  '',
  'twenty',
  'thirty',
  'forty',
  'fifty',
  'sixty',
  'seventy',
  'eighty',
  'ninety',
]

const INDIAN_GROUP_UNITS = ['', 'thousand', 'lakh', 'crore', 'arab', 'kharab']

const twoDigitWords = (number) => {
  if (number < 10) {
    return ONES[number]
  }
  if (number < 20) {
    return TEENS[number - 10]
  }
  const tenPart = TENS[Math.floor(number / 10)]
  const unitPart = number % 10 ? ` ${ONES[number % 10]}` : ''
  return `${tenPart}${unitPart}`
}

const threeDigitWords = (number) => {
  if (number < 100) {
    return twoDigitWords(number)
  }

  const hundredPart = `${ONES[Math.floor(number / 100)]} hundred`
  const remainder = number % 100
  if (!remainder) {
    return hundredPart
  }
  return `${hundredPart} and ${twoDigitWords(remainder)}`
}

const numberToIndianWords = (number) => {
  if (number === 0) {
    return 'zero'
  }

  let value = number
  const parts = []

  const lastThreeDigits = value % 1000
  if (lastThreeDigits) {
    parts.unshift(threeDigitWords(lastThreeDigits))
  }
  value = Math.floor(value / 1000)

  let unitIndex = 1
  while (value > 0 && unitIndex < INDIAN_GROUP_UNITS.length) {
    const groupValue = value % 100
    if (groupValue) {
      parts.unshift(
        `${threeDigitWords(groupValue)} ${INDIAN_GROUP_UNITS[unitIndex]}`.trim()
      )
    }
    value = Math.floor(value / 100)
    unitIndex += 1
  }

  if (value > 0) {
    parts.unshift(threeDigitWords(value))
  }

  if (parts.length > 1 && lastThreeDigits > 0 && lastThreeDigits < 100) {
    const prefix = parts.slice(0, -1).join(' ')
    const suffix = parts[parts.length - 1]
    return `${prefix} and ${suffix}`.replace(/\s+/g, ' ').trim()
  }

  return parts.join(' ').replace(/\s+/g, ' ').trim()
}

export const roundCurrencyAmount = (value) => {
  const amount = Number(value)
  if (!Number.isFinite(amount)) {
    return 0
  }
  return Math.round(amount)
}

export const formatRoundedIndianAmount = (value) => {
  const roundedAmount = roundCurrencyAmount(value)
  return roundedAmount.toLocaleString('en-IN')
}

export const amountInIndianWords = (value) => {
  const roundedAmount = roundCurrencyAmount(value)
  const absoluteValue = Math.abs(roundedAmount)
  const amountWords = numberToIndianWords(absoluteValue)
  const rupeeLabel = absoluteValue === 1 ? 'rupee' : 'rupees'
  const prefix = roundedAmount < 0 ? 'minus ' : ''
  return `${prefix}${amountWords} ${rupeeLabel}`
}
